import { Page } from 'components'
import { NavigationStructure } from 'components/UI/NavigationStructure'
import { PageStructure } from 'components/UI/PageStructure'
import { useLocation } from 'react-router-dom'
import { TSection, TSubsection } from 'types/AnalyticsInferfaces'
import { AnalyticsNavigation } from 'components/Analytics/NavigationsBar/AnalyticsNavigation'
import { AnalyticsContent } from '../../components/Analytics/AnalyticsContent'
import { AnalyticsSidebar } from '../../components/Analytics/AnalyticsSidebar'
import { useEffect } from 'react'
import { useAnalyticsStore } from 'stores/AnalyticsStore'

export const AnalyticsPage = () => {
  /* ------------------- VARIABLES  ------------------*/
  const location = useLocation()
  const section = (location.pathname.split('/')[2] ?? 'analytics') as TSection
  const subsection = (location.state?.subsection ?? 'setup') as TSubsection

  useEffect(() => {
    if (section === 'analytics') useAnalyticsStore.getState().clearStore()
  }, [section])

  return (
    <Page title="Analytics" checkPermission="analytics">
      <PageStructure
        sidebar={<AnalyticsSidebar section={section} />}
        content={<AnalyticsContent section={section} subsection={subsection} />}
        navigation={
          <NavigationStructure
            showNavigation={true}
            content={<AnalyticsNavigation section={section} subsection={subsection} />}
          />
        }
      />
    </Page>
  )
}
